import SectionLabel from "./SectionLabel";
import { FadeUp, MaskLine } from "./Reveal";

export default function WhatIsRecon() {
  return (
    <section data-testid="what-is-recon-section" className="border-b border-ink/15 bg-manila">
      <div className="mx-auto max-w-7xl px-6 py-28 md:px-10 md:py-40">
        <FadeUp>
          <div className="relative border border-ink/30 bg-bone px-8 py-14 md:px-16 md:py-20">
            <span className="absolute -top-4 left-10 border border-ink/30 border-b-0 bg-bone px-4 py-1.5 font-sans text-[10px] tracking-[0.35em] text-ink/60">
              FILE 001 // WHAT IS RECON?
            </span>

            <SectionLabel testid="what-is-recon-label">Your Briefing Has Arrived</SectionLabel>

            <h2 className="font-serif text-4xl font-medium leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl">
              <MaskLine>This is not just</MaskLine>
              <MaskLine delay={0.1}>
                <span className="italic text-wine">another event.</span>
              </MaskLine>
            </h2>

            <div className="mt-14 grid gap-12 md:grid-cols-2">
              <FadeUp delay={0.15} className="space-y-5 text-base leading-relaxed text-smoke md:text-lg">
                <p>
                  RECON is a gathering for women who understand that important moves deserve
                  intelligence. It is a place to pause long enough to assess your position. To
                  recognize what has changed. To identify what you don't know yet.
                </p>
                <p>
                  To gather wisdom from trusted sources. To exchange insight with the women in the
                  room. To hear what Heaven is saying. And to leave with greater clarity about what
                  your next move requires.
                </p>
              </FadeUp>
              <FadeUp delay={0.3} className="flex items-end">
                <p className="border-l-2 border-oxblood pl-8 font-serif text-2xl italic leading-snug text-ink md:text-3xl">
                  Because clarity isn't always found by moving faster. Sometimes —{" "}
                  <span className="text-wine">pause is reconnaissance.</span>
                </p>
              </FadeUp>
            </div>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
